import React, { useEffect, useMemo, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import { useParams } from "react-router-dom";
import Dymo from "dymo-connect";
import {
  AddLabelPrintLogLogAPI,
  getJobsLabelsData,
  GetOrdersDetailsAPI,
  getProductinUniqueDepartment,
  getProductionJobsData,
} from "../../Redux/orders";
import {
  Button,
  Checkbox,
  Empty,
  Input,
  message,
  Spin,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import {
  generateDeptTabsStyle,
  getDepartmentTagTheme,
} from "../../../helpers/utils";
import FullScreenLoader from "../../Components/FullScreenLoader";
import { PrinterOutlined, SyncOutlined } from "@ant-design/icons";
import {
  ProductFinishEnum,
  ProductFinishLabels,
} from "../Products/productsTypes";
import { JobLabelXml } from "../../../helpers/JobLabelXml";
import { SheetMetalDymoXml } from "../../../helpers/SheetMetalDymoXML";
import { DispatchDymoXML } from "../../../helpers/DispatchDymoXML";
import { WeldingDymoXML } from "../../../helpers/WeldingDymoXML";
import { PickingDymoXML } from "../../../helpers/PickingDymoXML";
import {
  CommonJobLabelInjectDataXML,
  createLabelDataItemsData,
  DispatchLabelInjectDataXML,
  PickingPackingLabelInjectDataXML,
  SheetMetalLabelInjectDataXML,
  WeldingLabelInjectDataXML,
} from "./PrintJobLabelHelper";
import { svg } from "../../../Assets/svg";
import ChangeLabelQtyModal from "./Components/Modals/ChangeLabelQtyModal";
import ViewPrintHistoryDetailsModal from "./Components/Modals/ViewPrintHistoryDetailsModal";
import EditLabelDataDrawer from "./Components/EditLabelDataDrawer";
import SelectPrinterModal from "./Components/Modals/SelectPrinterModal";

const getWeekNumber = (date: any) => {
  const d: any = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  const dayNum: any = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart: any = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNum: any = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNum;
};

const XMLAccourdingDepartment: any = {
  "sheet-matel": {
    xml: SheetMetalDymoXml,
  },
  dispatch: {
    xml: DispatchDymoXML,
  },
  welding: {
    xml: WeldingDymoXML,
  },
  "picking-packing": {
    xml: PickingDymoXML,
  },
};
const PrintJobLabel = () => {
  const dispatch = useAppDispatch();
  const { id, cat_snap_id } = useParams();
  const options = {
    hostname: "127.0.0.1",
    port: 41951,
  };
  const dymo = new Dymo(options);
  const {
    orderDetails,
    printedJobLabelData,
    getOrderProductionDepartment,
    productionJobsData,
  } = useAppSelector((state: RootState) => state.orders);
  const { getOrderProductionDepartmentLoading, getProductionJobsDataLoading } =
    useAppSelector((state: RootState) => state.loading);
  const [connectionStates, setConnectionStates] = useState({
    isPrinterError: false,
    isConnectionError: false,
    isConnectSuccess: false,
    isPrinterFound: false,
    connectedPrinterName: "",
  });
  const [printersList, setPrintersList] = useState<any[]>([]);
  const [selectedPrinterName, setSelectedPrinterName] = useState<string>("");
  const [connectionLoader, setConnectionLoader] = useState(false);
  const [refreshConnection, setRefreshConnection] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();
  const [activeKey, setActiveKey] = useState<any>("dispatch");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const [printLoader, setPrintLoader] = useState(false);
  const [previewImage, setPreviewImage] = useState<any>([]);

  const [openChangeQtyModal, setOpenChangeQtyModal] = useState(false);
  const [qtyEditData, setQtyEditData] = useState(null);

  const [openPrintHistoryModal, setOpenPrintHistoryModal] = useState(false);
  const [printHistoryData, setPrintHistoryData] = useState(null);

  const [openLabelEditDrawer, setOpenLabelEditDrawer] = useState(false);
  const [openSelectPrinterModal, setOpenSelectPrinterModal] = useState(false);

  const currentActiveKeyRef = React.useRef(activeKey);

  const [activeDepartmentSlug, setActiveDepartmentSlug] = useState(null);

  useEffect(() => {
    currentActiveKeyRef.current = activeKey;
  }, [activeKey]);

  console.log(previewImage, "previewImagepreviewImagepreviewImage");
  useEffect(() => {
    if (id) {
      dispatch(getJobsLabelsData({ order_id: id }));
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      dispatch(
        getProductinUniqueDepartment({
          order_id: id,
          categories_snapshot_id: cat_snap_id != "all" ? cat_snap_id : "",
        }),
      );
    }
  }, [id, cat_snap_id]);

  const handleCheckConnection = async () => {
    try {
      setConnectionLoader(true);
      const printers: any = await dymo.getPrinters();

      if (printers?.success) {
        if (printers?.data?.length === 0) {
          setConnectionStates((prev) => ({
            ...prev,
            isPrinterError: true,
            isConnectionError: false,
            isConnectSuccess: true,
            isPrinterFound: false,
            connectedPrinterName: "",
          }));
        } else {
          const connectedPrinter =
            printers?.data?.find((p: any) => p.connected) ||
            printers?.data?.[0];
          setConnectionStates((prev) => ({
            ...prev,
            isPrinterError: false,
            isConnectionError: false,
            isConnectSuccess: true,
            isPrinterFound: true,
            connectedPrinterName: connectedPrinter?.name || "",
          }));
        }
      } else {
        setConnectionStates((prev) => ({
          ...prev,
          isPrinterError: false,
          isConnectionError: true,
          isConnectSuccess: false,
          isPrinterFound: false,
          connectedPrinterName: "",
        }));
      }
    } catch (error) {
      setConnectionStates((prev) => ({
        ...prev,
        isPrinterError: false,
        isConnectionError: true,
        isConnectSuccess: false,
        isPrinterFound: false,
        connectedPrinterName: "",
      }));
    } finally {
      setTimeout(() => {
        if (refreshConnection > 1) {
          messageApi.success("Connection refreshed successfully");
        }
        setConnectionLoader(false);
      }, 500);
    }
  };

  useEffect(() => {
    handleCheckConnection();
  }, [refreshConnection]);

  useEffect(() => {
    if (!id) return;
    dispatch(GetOrdersDetailsAPI({ order_id: id }));
  }, [id, dispatch]);

  const items: TabsProps["items"] = useMemo(() => {
    if (getOrderProductionDepartment?.length > 0) {
      const data = getOrderProductionDepartment.map((elem: any) => ({
        key: elem?._id,
        label: `${elem?.name} ${
          elem?.incomplete_count > 0 || elem?.complete_count > 0
            ? `(${elem?.incomplete_count + elem?.complete_count})`
            : ""
        }`,
        slug: elem?.slug ? elem?.slug : null,
        children: "",
      }));
      return [
        // { key: "all", label: "All" },
        { key: "dispatch", label: "Dispatch" },
        ...data,
      ];
    }
    return [];
  }, [getOrderProductionDepartment]);

  const deptTabsCss = useMemo(() => {
    return generateDeptTabsStyle(
      "printJobLabelDeptTabs",
      getOrderProductionDepartment,
      activeKey,
    );
  }, [getOrderProductionDepartment, activeKey]);

  useEffect(() => {
    if (activeKey && id) {
      const payload = {
        order_id: id,
        department_id: ["all", "dispatch"]?.includes(activeKey)
          ? ""
          : activeKey,
        categories_snapshot_id: cat_snap_id != "all" ? cat_snap_id : "",
      };
      dispatch(getProductionJobsData(payload));
      setLoadingPrint(true);
    }
  }, [activeKey, id]);

  const renderLabales = async () => {
    const keyWhenStarted = activeKey;
    setLoadingPrint(true);
    try {
      let results = [];
      // if (activeKey == "all") {
      //   const dispatchResult = await DispatchLabelInjectDataXML(
      //     labelDataItems?.map((elem:any)=>elem?.printed_data ),
      //     dymo,
      //   );
      //   const packingResult = await PickingPackingLabelInjectDataXML(
      //     labelDataItems,
      //     dymo,
      //   );
      //   const findWeldingData = labelDataItems?.filter(
      //     (elem: any) => elem?.slug === "welding",
      //   );
      //   const weldingResult = await WeldingLabelInjectDataXML(
      //     findWeldingData,
      //     dymo,
      //   );
      //   const findSheetMetalData = labelDataItems?.filter(
      //     (elem: any) => elem?.slug === "sheet-metal",
      //   );
      //   const sheetMetalResult = await SheetMetalLabelInjectDataXML(
      //     findSheetMetalData,
      //     dymo,
      //   );
      //   const commonData = labelDataItems?.filter(
      //     (elem: any) =>
      //       elem?.slug !== "sheet-metal" && elem?.slug !== "welding",
      //   );
      //   const commonResult = await CommonJobLabelInjectDataXML(
      //     commonData,
      //     dymo,
      //   );
      //   results = [
      //     ...dispatchResult,
      //     ...packingResult,
      //     ...weldingResult,
      //     ...sheetMetalResult,
      //     ...commonResult,
      //   ]?.map((elem: any, index: any) => ({ ...elem, id: index + 1 }));
      // } else
      if (activeKey == "dispatch") {
        const labelDataItems = await createLabelDataItemsData(
          productionJobsData,
          orderDetails,
          activeKey,
        );
        const dispatchResult = await DispatchLabelInjectDataXML(
          labelDataItems,
          dymo,
        );
        results = [...dispatchResult];
      } else {
        const labelDataItems = await createLabelDataItemsData(
          productionJobsData,
          orderDetails,
          activeKey,
        );
        if (labelDataItems?.[0]?.slug == "welding") {
          const weldingResult = await WeldingLabelInjectDataXML(
            labelDataItems,
            dymo,
          );
          results = [...weldingResult];
        } else if (labelDataItems?.[0]?.slug == "sheet-metal") {
          const sheetMetalResult = await SheetMetalLabelInjectDataXML(
            labelDataItems,
            dymo,
          );
          results = [...sheetMetalResult];
        } else if (labelDataItems?.[0]?.slug == "picking-packing") {
          const packingResult = await PickingPackingLabelInjectDataXML(
            labelDataItems,
            dymo,
          );
          results = [...packingResult];
        } else {
          results = await CommonJobLabelInjectDataXML(labelDataItems, dymo);
        }
      }
      if (currentActiveKeyRef.current !== keyWhenStarted) return;
      setPreviewImage(results?.filter(Boolean));
    } catch (error) {
      console.error("handleRender error:", error);
      message.error("Failed to generate label previews.");
    } finally {
      if (currentActiveKeyRef.current === keyWhenStarted) {
        setLoadingPrint(false);
      }
    }
  };

  useEffect(() => {
    if (
      productionJobsData?.length > 0 ||
      (!getProductionJobsDataLoading && orderDetails)
    ) {
      renderLabales();
    }
  }, [productionJobsData, orderDetails]);

  const handleOpenPrintModal = () => {
    const selectedLabels = previewImage?.filter((elem: any) => elem?.selected);
    if (!selectedLabels || selectedLabels?.length === 0) {
      message.error("Please select at least one label for printing");
      return;
    }
    setOpenSelectPrinterModal(true);
  };

  const handlePrint = async (printerName: string): Promise<void> => {
    const selectedLabels = previewImage?.filter((elem: any) => elem?.selected);
    if (selectedLabels?.length === 0) {
      message.error("Please select at least one label for printing");
      return;
    }

    if (!printerName) {
      message.error("Please select a printer to send print job.");
      return;
    }

    try {
      setPrintLoader(true);
      const sleep = (ms: number) =>
        new Promise((resolve) => setTimeout(resolve, ms));

      for (let i = 0; i < selectedLabels.length; i++) {
        const elem = selectedLabels[i];
        const cleaned = elem?.XML?.replace(/{{\s*[^}]+\s*}}/g, "");

        await dymo.printLabel(printerName, cleaned, {
          copies: elem?.copies ? elem?.copies : 1,
          jobTitle: `SM-CRM Job print ${elem?.id}`,
        });
        await sleep(300);
        let extra: any = {};

        if (elem?.label_data?.printed_data?.extra_data?.date) {
          extra.date = elem?.label_data?.printed_data?.extra_data?.date;
        }
        if (elem?.label_data?.printed_data?.extra_data?.dispatch_user) {
          extra.dispatch_user = {
            name: elem?.label_data?.printed_data?.extra_data?.dispatch_user
              ?.name,
            first_name:
              elem?.label_data?.printed_data?.extra_data?.dispatch_user
                ?.first_name,
            last_name:
              elem?.label_data?.printed_data?.extra_data?.dispatch_user
                ?.last_name,
            _id: elem?.label_data?.printed_data?.extra_data?.dispatch_user
              ?._id,
          };
        }

        if (elem?.label_data?.printed_data?.extra_data?.collection_status) {
          extra.collection_status =
            elem?.label_data?.printed_data?.extra_data?.collection_status;
        }
        if (elem?.label_data?.printed_data?.extra_data?.quantity) {
          extra.quantity =
            elem?.label_data?.printed_data?.extra_data?.quantity;
        }
        if (elem?.label_data?.printed_data?.extra_data?.number_of_batches) {
          extra.number_of_batches =
            elem?.label_data?.printed_data?.extra_data?.number_of_batches;
        }
        if (elem?.label_data?.printed_data?.extra_data?.batch_qauntity) {
          extra.batch_qauntity =
            elem?.label_data?.printed_data?.extra_data?.batch_qauntity;
        }
        const payload = {
          order_id: orderDetails?._id,
          label_id: elem?.label_data?._id,
          department_id: elem?.label_data?.department_id,
          department_name: elem?.label_data?.department_name,
          qty: elem?.copies ? elem?.copies : 1,
          extra_data: extra,
        };
        const handleSuccess = (data: any) => {
          setPreviewImage((prev: any) =>
            prev?.map((el: any) =>
              el?.label_data?._id === data?.label_id
                ? {
                    ...el,
                    label_data: {
                      ...el?.label_data,
                      printed_data: {
                        ...(el?.label_data?.printed_data || {}),
                        ...data,
                      },
                    },
                  }
                : el,
            ),
          );
        };
        dispatch(AddLabelPrintLogLogAPI(payload, handleSuccess));
      }
      message.success(`Print jobs successfully sent to ${printerName}`);
    } catch (error: any) {
      console.error("Printing failed:", error);
      message.error(error?.message || "Not able to print");
    } finally {
      setPrintLoader(false);
    }
  };

  const handleSelectAll = (checked: boolean) => {
    setPreviewImage((prev: any) =>
      prev.map((item: any) => ({ ...item, selected: checked })),
    );
  };

  const isAllSelected =
    previewImage?.length > 0 &&
    previewImage?.every((item: any) => item.selected);
  const isAnySelected = previewImage?.some((item: any) => item.selected);

  const handleEditLabelData = () => {
    setOpenLabelEditDrawer(true);
  };
  return getOrderProductionDepartmentLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="page-content h-100 px-40 py-40">
      {contextHolder}
      <div className="mb-sm-3 mb-2 d-flex flex-column gap-md-2 gap-0">
        <div className="d-flex flex-md-nowrap flex-wrap gap-md-3 gap-2 column-gap-2 justify-content-between align-items-center">
          <h2 className="text-black fs-36 fw-bolder page-title mb-0 order-md-1 order-1">
            Print Labels
          </h2>
          <div
            className={`d-flex flex-md-nowrap flex-wrap gap-sm-3 gap-2 justify-content-end align-items-center ms-auto order-sm-2 order-3`}
          >
            <div className="d-flex align-items-center gap-1">
              <Tooltip
                title={
                  connectionStates?.isConnectSuccess &&
                  !connectionStates?.isPrinterError
                    ? `${connectionStates?.connectedPrinterName || "Dymo"} Connected`
                    : connectionStates?.isPrinterError
                    ? "Dymo Service Connected But Printer Not Found"
                    : "Dymo Service Not Connected"
                }
              >
                <span
                  className={
                    "d-inline-flex align-items-center billStatus " +
                    (connectionStates?.isConnectSuccess &&
                    !connectionStates?.isPrinterError
                      ? "approvedStatus"
                      : "expiredStatus")
                  }
                >
                  <PrinterOutlined />
                  {connectionStates?.isConnectSuccess &&
                  !connectionStates?.isPrinterError
                    ? "Connected"
                    : connectionStates?.isPrinterError
                    ? "Printer Not Found"
                    : "Disconnected"}
                </span>
              </Tooltip>

              <span
                className="svg-16 d-flex align-items-center justify-content-center"
                role="button"
                onClick={() => {
                  setRefreshConnection((prev) => prev + 1);
                }}
              >
                <Tooltip title="Refresh Dymo Printer Connection">
                  <SyncOutlined spin={connectionLoader} className="ms-1" />
                </Tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="customHorizontalTabs printJobLabelDeptTabs bg-white overflow-hidden border-0 rounded-3 d-inline-block mw-100">
            {deptTabsCss && <style>{deptTabsCss}</style>}
            <Tabs
              activeKey={activeKey}
              onChange={(key: string) => {
                const selectedItem: any = items.find(
                  (item) => item.key === key,
                );
                setActiveDepartmentSlug(
                  selectedItem?.slug ? selectedItem?.slug : null,
                );
                setActiveKey(key);
                setPreviewImage([]);
              }}
              items={items?.map(({ label, key }) => ({
                label,
                key,
              }))}
            />
          </div>
        
        </div>
          <div className="d-flex align-items-center gap-3 justify-content-end mb-3">
            {previewImage?.length > 0 && (
              <Checkbox
                checked={isAllSelected}
                indeterminate={!isAllSelected && isAnySelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
                className="fw-bold fs-6 custom-checkbox"
              >
                SELECT ALL
              </Checkbox>
            )}
            <Button
              type="primary"
              size="large"
              icon={<PrinterOutlined />}
              onClick={handleOpenPrintModal}
              loading={printLoader}
              disabled={!isAnySelected || loadingPrint}
              className="px-4"
            >
              PRINT SELECTED (
              {previewImage?.filter((i: any) => i.selected).length})
            </Button>
            {activeKey == "all" ? (
              ""
            ) : activeDepartmentSlug == "picking-packing" ||
              activeDepartmentSlug == "sheet-metal" ||
              activeKey == "dispatch" ? (
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  handleEditLabelData();
                }}
                disabled={!isAnySelected || loadingPrint}
                className="px-4"
              >
                EDIT LABELS
              </Button>
            ) : (
              ""
            )}
          </div>
        <div className="fs-6 fw-medium mb-1">
          <span className="fw-bold text-primary">Notes* :</span>
          {` Values inside {{ }} are placeholders and won’t be printed. You can modify them from the EDIT LABELS section.`}
        </div>
        <div className="fs-6 fw-medium mb-2">
          <span className="fw-bold text-primary">Notes* :</span>
          {` Please complete Production Planning first. Once production is scheduled, all planned parts, components, and variants will appear here for label printing.`}
        </div>
        <div className="bg-white p-4 rounded-3 shadow-sm min-h-400">
          {getProductionJobsDataLoading || loadingPrint ? (
            <div className="d-flex justify-content-center align-items-center h-100 py-5">
              <div style={{ textAlign: "center" }}>
                <Spin size="large" />
                <div style={{ marginTop: 10 }}>Generating labels...</div>
              </div>
            </div>
          ) : previewImage?.length > 0 ? (
            <div className="row gy-4">
              {previewImage?.map((elem: any) => {
                // debugger
                return (
                  <div className="col-lg-3 col-md-6" key={elem.id}>
                    <div className="d-flex gap-2 transition-all flex-column">
                      <div className="d-flex justify-content-between">
                        <div className="d-flex gap-2">
                          <Checkbox
                            checked={elem.selected}
                            onChange={(e) => {
                              setPreviewImage((prev: any) =>
                                prev.map((item: any) =>
                                  item.id === elem.id
                                    ? { ...item, selected: e.target.checked }
                                    : item,
                                ),
                              );
                            }}
                            className="fw-bold fs-6 custom-checkbox"
                          />
                          {elem?.data?.qty ? (
                            <span
                              className="svg-23 d-flex align-items-center"
                              onClick={() => {
                                setOpenChangeQtyModal(true);
                                setQtyEditData(elem);
                              }}
                            >
                              {svg?.tableEditIcon}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <div className="d-flex align-items-center gap-1">
                            <label className="custom-label ff">Copies</label>
                            <Input
                              style={{ maxWidth: "50px" }}
                              name="copies"
                              type="number"
                              value={elem?.copies || 1}
                              className="form-control form-control-sm"
                              placeholder="Manufactured Qty"
                              onWheel={(e: any) => e.target.blur()}
                              onKeyDown={(e: any) => {
                                const allowedKeys = [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ];

                                if (
                                  allowedKeys.includes(e.key) ||
                                  (e.key >= "0" && e.key <= "9")
                                ) {
                                  return;
                                }

                                e.preventDefault();
                              }}
                              onChange={(e) => {
                                const value = e?.target?.value;
                                setPreviewImage((prev: any) =>
                                  prev?.map((item: any) =>
                                    item?.id === elem?.id
                                      ? { ...item, copies: value }
                                      : item,
                                  ),
                                );
                              }}
                            />
                          </div>
                          {elem?.label_data?.printed_data?.print_by?.length >
                          0 ? (
                            <Tooltip
                              title={"Click here to view the print history"}
                            >
                              <span
                                className={
                                  "d-inline-flex align-items-center billStatus approvedStatus fw-semibold"
                                }
                                role="button"
                                onClick={() => {
                                  setPrintHistoryData(elem);
                                  setOpenPrintHistoryModal(true);
                                }}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Printed
                              </span>
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <img
                          src={elem.preview}
                          alt={`Label ${elem.id}`}
                          className="img-fluid rounded shadow-sm border"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <Empty
              description="No labels available for this department"
              className="py-5"
            />
          )}
        </div>
      </div>
      {openChangeQtyModal && (
        <ChangeLabelQtyModal
          visible={openChangeQtyModal}
          setIsModalVisible={setOpenChangeQtyModal}
          editData={qtyEditData}
          dymo={dymo}
          setPreviewImage={setPreviewImage}
          setEditData={setQtyEditData}
        />
      )}
      {openPrintHistoryModal && (
        <ViewPrintHistoryDetailsModal
          visible={openPrintHistoryModal}
          setIsModalVisible={setOpenPrintHistoryModal}
          printHistoryData={printHistoryData}
          setPrintHistoryData={setPrintHistoryData}
          setPreviewImage={setPreviewImage}
        />
      )}
      {openLabelEditDrawer && (
        <EditLabelDataDrawer
          isOpen={openLabelEditDrawer}
          setIsOpen={setOpenLabelEditDrawer}
          setPreviewImage={setPreviewImage}
          previewImage={previewImage}
          dymo={dymo}
          activeDepartmentSlug={activeDepartmentSlug}
          activeKey={activeKey}
        />
      )}
      {openSelectPrinterModal && (
        <SelectPrinterModal
          visible={openSelectPrinterModal}
          setIsModalVisible={setOpenSelectPrinterModal}
          dymo={dymo}
          onSendPrint={handlePrint}
          printLoader={printLoader}
        />
      )}
    </div>
  );
};

export default PrintJobLabel;
